import React from 'react';
import { Provider } from 'react-intl-redux';
import ChatWidgetWrapper from "../components/ChatWidget/ChatWidgetWrapper";
import configureStore from '../store/findBobPublicStore';
import { createIntlCache, IntlProvider } from 'react-intl';
import { updateIntl } from 'react-intl-redux';
import getMessages from '../lib/i18n/getMessages';

const ChatWidgetContainer = props => {

	const cache = createIntlCache();

	const setIntl = () => {
	updateIntl(
	{
		locale   : 'en',
		messages : getMessages(window.locale || 'en'),
	},
	cache
	);}

	let store = document.store;
	if (!store) {
		store = configureStore(props);
		document.store = store;
	}

	setIntl();
	return (
		<Provider store={document.store} {...props}>
			<IntlProvider messages={getMessages(window.locale || 'en')} locale={window.locale || 'en'}>
				<ChatWidgetWrapper {...props} />
			</IntlProvider>
		</Provider>
	);
}

export default ChatWidgetContainer;